let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aQa7o")).then(() => parcelRequire('3EYJt'));